
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CreditCardForm } from "./CreditCardForm";
import { StripeProvider } from "./StripeProvider";

interface PaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  amount: number;
  onPaymentSuccess: (paymentId: string) => void;
}

export const PaymentModal = ({ isOpen, onClose, amount, onPaymentSuccess }: PaymentModalProps) => {
  const handleSuccess = (paymentId: string) => {
    onPaymentSuccess(paymentId);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="text-center text-2xl">Enter Payment Details</DialogTitle>
        </DialogHeader>
        <StripeProvider>
          <CreditCardForm amount={amount} onSuccess={handleSuccess} />
        </StripeProvider>
      </DialogContent>
    </Dialog>
  );
};
